<template>
  <team-form
    :value="team"
  />
</template>

<script>
import TeamForm from "../Edit.vue"

export default {
  components: { TeamForm },
  props: {
		team: {
			type: Object,
			required: true,
			default: () => {}
		}
	}
}
</script>
